import React from 'react';
import { bool, node, string } from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { routes } from '@constants';
import { storage } from '@utils';
import { SectionNav } from '@molecules';

const AuthorizedRoute = ({ exact, path, children }) => {
  const token = storage.getToken();

  if (!token) {
    return <Redirect to={routes.login} />;
  }

  return (
    <Route exact={exact} path={path}>
      <SectionNav />
      {children}
    </Route>
  );
};

AuthorizedRoute.defaultProps = {
  exact: false,
};

AuthorizedRoute.propTypes = {
  exact: bool,
  path: string.isRequired,
  children: node.isRequired,
};

export default AuthorizedRoute;
